import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getSkillPathDetails = (skillPathId) => {
  return base.get({
    url: API_PARAM.SKILL_PATH_DETAILS,
    params: { id: skillPathId },
  });
};

export const getSkillPathContents = (skillPathId) => {
  return base.get({
    url: API_PARAM.SKILL_PATH_CONTENTS,
    params: { id: skillPathId },
  });
};

export const getSkillPathSkills = (skillPathId) => {
  return base.get({
    url: API_PARAM.SKILL_PATH_SKILLS,
    params: { id: skillPathId },
  });
};

export const getSkillPathGoals = (skillPathId) => {
  return base.get({
    url: API_PARAM.SKILL_PATH_GOALS,
    params: { id: skillPathId },
  });
};

export const getUserJobRecommendedSkillPaths = () => {
  return base.get({
    url: API_PARAM.USERS_JOB_RECOMMENDED_SKILL_PATHS,
  });
};

export const getInProgressSkillPaths = () => {
  return base.get({
    url: API_PARAM.SKILLPATHS_IN_PROGRESS,
  });
};

